import api from './client';

export const customerOrderHistoryApi = {
  getList: (limit = 100, offset = 0, filters = {}) => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('offset', offset);
    if (filters.textQuery) {
      params.append('text_query', filters.textQuery);
    }
    if (filters.textExact) {
      params.append('text_exact', 'true');
    }
    if (filters.startDate) {
      params.append('start_date', filters.startDate);
    }
    if (filters.endDate) {
      params.append('end_date', filters.endDate);
    }
    return api.get(`/api/customer-order-history?${params.toString()}`);
  },
};
